
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Modified_Evans_classification_of_intertrochanteric_fractures',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Modified_Evans_classification_of_intertrochanteric_fractures.vue